import { render, staticRenderFns } from "./UserAuditLogs.vue?vue&type=template&id=5dade946&scoped=true&"
import script from "./UserAuditLogs.vue?vue&type=script&lang=ts&"
export * from "./UserAuditLogs.vue?vue&type=script&lang=ts&"
import style0 from "./UserAuditLogs.vue?vue&type=style&index=0&id=5dade946&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dade946",
  null
  
)

export default component.exports